import { render, staticRenderFns } from "./PromoteBanner.vue?vue&type=template&id=b33d4fc8&"
import script from "./PromoteBanner.vue?vue&type=script&lang=js&"
export * from "./PromoteBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports